import { render, staticRenderFns } from "./HistoryItemDefault.vue?vue&type=template&id=c6b51bba&scoped=true&"
import script from "./HistoryItemDefault.vue?vue&type=script&lang=js&"
export * from "./HistoryItemDefault.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemDefault.vue?vue&type=style&index=0&id=c6b51bba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b51bba",
  null
  
)

export default component.exports